import { render, staticRenderFns } from "./ImotInfo.vue?vue&type=template&id=a3e64516"
import script from "./ImotInfo.vue?vue&type=script&lang=js"
export * from "./ImotInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports